import IconResolver from "../../../../../../../shared/components/common/ui/IconResolver";
import { Stack } from "@mui/material";
import StatusBadge from "../../../../../../../shared/components/common/ui/StatusBadge";
import TemplatePreviewCell from "../../../../../../templates//components/MessagePreview/TemplatePreviewCell";
import CostPreviewChip from "../../../../../../templates/components/MessagePricing/CostPreviewChip";

const textCol = (extra = {}) => ({
  flex: 1,
  minWidth: 180,
  ...extra,
});

const mediumCol = (extra = {}) => ({
  flex: 1,
  minWidth: 220,
  ...extra,
});

const wideCol = (extra = {}) => ({
  flex: 1,
  minWidth: 360,
  ...extra,
});

export const EMPTY_PREVIEW = {
  channel: null,
  messages: [],
};

export const TEMPLATE_COLUMNS = [
  {
    headerName: "Canal",
    field: "channel_type",
    width: 100,
    renderCell: (params) => {
      return <IconResolver name={params.value} />;
    },
  },
  {
    field: "title",
    headerName: "Nome",
    ...textCol(),
  },
  {
    field: "message_tag",
    headerName: "Categoria",
    ...textCol(),
  },

  {
    field: "cost_per_message",
    headerName: "Custo por mensagem",
    ...mediumCol({
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderHeader: () => (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ cursor: "pointer" }}
        >
          <span>Custo por mensagem</span>
        </Stack>
      ),
      renderCell: (params) => {
        const { channel_type, message_meta_tier } = params.row;
        return (
          <CostPreviewChip
            channelType={channel_type}
            costCategory={message_meta_tier}
          />
        );
      },
    }),
  },
  {
    field: "message_json",
    headerName: "Mensagem",
    ...wideCol({
      sortable: false,
      renderCell: (params) => <TemplatePreviewCell row={params.row} />,
    }),
  },

  {
    field: "status",
    headerName: "Status",
    ...textCol({
      renderCell: (params) => <StatusBadge status={params.value} />,
    }),
  },
];
